import { ReactNode, useId } from 'react'

type IProps = {
  title: string
  children: ReactNode
  footer?: ReactNode
  defaultOpen?: boolean
  collapseId?: string
}

export const CustomCard = ({ title, children, footer, defaultOpen = true, collapseId }: IProps) => {
  const generatedId = useId()
  const id = collapseId || `custom_card_${generatedId}`

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target={`#${id}`}
        aria-expanded={defaultOpen}
        aria-controls={id}
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>{title}</h3>
        </div>
      </div>

      <div id={id} className={`collapse ${defaultOpen ? 'show' : ''}`}>
        <div className='card-body'>{children}</div>

        {footer && <div className='card-footer d-flex justify-content-end py-6 px-9'>{footer}</div>}
      </div>
    </div>
  )
}
